import React, { useEffect, useState } from 'react';
import { CheckIcon, ClockIcon, LockIcon, ShieldCheckIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, BookOpenIcon, HeartHandshakeIcon, MessageCircleIcon, FileTextIcon, BrainCircuitIcon, UsersIcon, TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCard } from './components/PricingCard';
import { TestimonialCard } from './components/TestimonialCard';
import { BonusCard } from './components/BonusCard';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ImageCarousel } from './components/ImageCarousel';
import { FAQItem } from './components/FAQItem';
import { Footer } from './components/Footer';
export function App() {
  const [selectedPrice, setSelectedPrice] = useState('$28.990');
  const scrollToPricing = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    const packSection = document.getElementById('elegi-tu-pack');
    if (packSection) {
      packSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  useEffect(() => {
    const eliteRadio = document.getElementById('pack-elite') as HTMLInputElement;
    const baseRadio = document.getElementById('pack-base') as HTMLInputElement;
    const updatePrice = () => {
      if (eliteRadio?.checked) {
        setSelectedPrice('$28.990');
      } else if (baseRadio?.checked) {
        setSelectedPrice('$19.990');
      }
    };
    eliteRadio?.addEventListener('change', updatePrice);
    baseRadio?.addEventListener('change', updatePrice);
    return () => {
      eliteRadio?.removeEventListener('change', updatePrice);
      baseRadio?.removeEventListener('change', updatePrice);
    };
  }, []);
  return <div className="min-h-screen bg-[#FAF9F6] font-sans text-gray-900" data-id="element-0">
      {/* STICKY ALERT BAR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#C0392B] text-black py-1.5 px-2 shadow-lg" data-id="element-1">
        <div className="max-w-7xl mx-auto flex flex-row items-center justify-center gap-1.5 sm:gap-2" data-id="element-2">
          <div className="flex items-center gap-1 text-[10px] sm:text-[11px] font-bold whitespace-nowrap" data-id="element-3">
            <span className="text-[11px]" data-id="element-4">⏰</span>
            <span data-id="element-5">PRECIO DE LANZAMIENTO — Cierra en:</span>
          </div>
          <div className="font-extrabold text-sm sm:text-base text-black" data-id="element-6">
            <CountdownTimer key="sticky-timer" initialMinutes={15} data-id="element-7" />
          </div>
          <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-2.5 py-0.5 sm:px-3 sm:py-1 rounded-full text-[10px] sm:text-[11px] font-bold transition-all whitespace-nowrap shadow-lg" data-id="element-8">
            ASEGURAR PRECIO
          </button>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="pt-16 pb-12 md:pt-20 md:pb-16 px-4 bg-[#2C3E50] text-white overflow-hidden relative" data-id="element-9">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-10"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10 space-y-6" data-id="element-11">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight px-2" data-id="element-12">
            Recuperá la conexión con tu pareja y la calma en tu relación en{' '}
            <span className="text-[#FFD700]" data-id="element-13">SOLO 24 HS</span>
          </h1>
          <p className="text-lg md:text-2xl font-semibold text-gray-300 -mt-3" data-id="element-14">
            Sin meses de terapia.
          </p>

          <div className="relative mx-auto w-full max-w-2xl my-8" data-id="element-15">
            <div className="absolute inset-0 bg-[#27AE60]/20 blur-3xl rounded-full" data-id="element-16"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cjETWVAjw5UE9AmyA8Hrve/MOCK_UP_PRINCIPAL.png" alt="Mockup del Método Reset 24h + 4 Bonos + Tablet" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-17" />
          </div>

          <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-3xl mx-auto" data-id="element-18">
            <strong data-id="element-19">El Método Reset 24h:</strong> una guía práctica para frenar
            el conflicto, redefinir las reglas invisibles y empezar a cambiar la
            dinámica de tu relación en tiempo récord.
          </p>

          <div className="flex flex-wrap justify-center gap-3 text-sm font-medium" data-id="element-20">
            <div className="bg-[#2C3E50] border-2 border-[#27AE60] px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-21">
              <CheckIcon className="w-4 h-4 text-[#27AE60]" data-id="element-22" />
              📄 100% Digital (PDF)
            </div>
            <div className="bg-[#2C3E50] border-2 border-[#27AE60] px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-23">
              <CheckIcon className="w-4 h-4 text-[#27AE60]" data-id="element-24" />⚡ Acceso
              inmediato
            </div>
            <div className="bg-[#2C3E50] border-2 border-[#27AE60] px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-25">
              <CheckIcon className="w-4 h-4 text-[#27AE60]" data-id="element-26" />
              🛡️ Compra oficial verificada
            </div>
          </div>

          <div className="space-y-3" data-id="element-27">
            <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center gap-2 animate-pulse" data-id="element-28">
              QUIERO RECUPERAR MI RELACIÓN AHORA
              <TrendingUpIcon className="w-5 h-5" data-id="element-29" />
            </button>
            <p className="text-sm text-gray-300 flex items-center justify-center gap-2" data-id="element-30">
              <LockIcon className="w-4 h-4" data-id="element-31" />
              Garantía 7 días · Pago 100% seguro · Mercado Pago
            </p>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-32">
        <div className="max-w-4xl mx-auto" data-id="element-33">
          <div className="text-center mb-8" data-id="element-34">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-35">
              😔 Si estás en pareja, esto te va a sonar familiar...
            </h2>
            <div className="w-20 h-1 bg-[#27AE60] mx-auto rounded-full" data-id="element-36"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-3" data-id="element-37">
            {['💔 Te sentís más como compañero de cuarto que como pareja.', '😤 Las discusiones se disparan por cualquier cosa y nunca se resuelven.', '🤐 El silencio en casa es más fuerte que cualquier grito.', '🗣️ Sentís que hablás y no te escuchan.', '💞 El amor todavía está ahí, pero la conexión parece rota.'].map((pain, idx) => <div key={idx} className="bg-white border-2 border-[#E74C3C] p-4 rounded-lg hover:shadow-md transition-shadow" data-id="element-38">
                <p className="text-base text-gray-700 font-medium" data-id="element-39">{pain}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WHY PREVIOUS FAILED */}
      <section className="py-12 md:py-16 px-4 bg-[#FAF9F6] border-y border-gray-200" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-4 text-center" data-id="element-42">
            ❌ No es tu culpa: nadie te dio una herramienta para desactivar la
            crisis en tiempo real.
          </h2>
          <p className="text-gray-600 mb-6 text-base text-center" data-id="element-43">
            Esto es lo que volvió a fallar una y otra vez:
          </p>
          <div className="grid md:grid-cols-3 gap-4 max-w-3xl mx-auto" data-id="element-44">
            <div className="bg-white border-2 border-[#E74C3C] p-4 rounded-lg" data-id="element-45">
              <div className="text-2xl mb-2" data-id="element-46">🧠</div>
              <strong className="text-gray-900 block mb-1" data-id="element-47">
                Cerebro Secuestrado
              </strong>
              <p className="text-sm text-gray-700" data-id="element-48">
                Intentar hablar cuando la emoción domina la razón.
              </p>
            </div>
            <div className="bg-white border-2 border-[#E74C3C] p-4 rounded-lg" data-id="element-49">
              <div className="text-2xl mb-2" data-id="element-50">⏰</div>
              <strong className="text-gray-900 block mb-1" data-id="element-51">
                La Trampa del Tiempo
              </strong>
              <p className="text-sm text-gray-700" data-id="element-52">
                Esperar que "pase solo" mientras el resentimiento se agrava.
              </p>
            </div>
            <div className="bg-white border-2 border-[#E74C3C] p-4 rounded-lg" data-id="element-53">
              <div className="text-2xl mb-2" data-id="element-54">💔</div>
              <strong className="text-gray-900 block mb-1" data-id="element-55">
                Falta de Logística
              </strong>
              <p className="text-sm text-gray-700" data-id="element-56">
                Creer que el amor es suficiente sin herramientas de gestión.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCT PRESENTATION */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-57">
        <div className="max-w-4xl mx-auto text-center" data-id="element-58">
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#2C3E50] mb-4" data-id="element-59">
            💚 Salva Tu Relación:{' '}
            <span className="text-[#27AE60]" data-id="element-60">El Método Reset 24h</span>
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed" data-id="element-61">
            El plan paso a paso para que en menos de 24 horas puedas detener el
            incendio emocional en tu relación, reescribir las reglas invisibles
            y reconstruir la conexión.
          </p>

          <div className="bg-[#FAF9F6] rounded-2xl p-8 text-left mb-12 border-2 border-[#27AE60] shadow-sm" data-id="element-62">
            <h3 className="text-xl font-bold text-[#2C3E50] mb-6 text-center" data-id="element-63">
              Beneficios concretos que vas a lograr:
            </h3>
            <div className="space-y-4 max-w-2xl mx-auto" data-id="element-64">
              <div className="flex items-start gap-4" data-id="element-65">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-66">
                  <CheckIcon className="w-6 h-6 text-[#27AE60]" data-id="element-67" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-68">
                  Detener una discusión en <strong data-id="element-69">3 minutos</strong> sin que
                  escale.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-70">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-71">
                  <CheckIcon className="w-6 h-6 text-[#27AE60]" data-id="element-72" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-73">
                  Poder hablar sin que el otro se ponga a la defensiva.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-74">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-75">
                  <CheckIcon className="w-6 h-6 text-[#27AE60]" data-id="element-76" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-77">
                  Redefinir acuerdos claros sobre temas que hoy generan peleas
                  (dinero, hijos, intimidad, rutinas).
                </p>
              </div>
            </div>
          </div>

          <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-10 py-5 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 animate-pulse" data-id="element-78">
            QUIERO LA SOLUCIÓN AHORA
            <CheckIcon className="w-6 h-6" data-id="element-79" />
          </button>
        </div>
      </section>

      {/* PRODUCT PREVIEW */}
      <section className="py-12 md:py-16 px-4 bg-[#2C3E50] text-white overflow-hidden" data-id="element-80">
        <div className="max-w-6xl mx-auto text-center" data-id="element-81">
          <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-82">
            📖 Mirá por dentro el Método Reset 24h:
          </h2>
          <ImageCarousel images={[{
          src: 'https://cdn.magicpatterns.com/uploads/7CrVGAU7fwVgDt98D7PTHu/imagen_1.png',
          alt: 'Los 3 Momentos más Difíciles que Superamos'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/tBK4vgU3ZtC3R5n9dE5uYe/imagen_3.png',
          alt: 'La Técnica STOP: Dejar de Reaccionar para Empezar a Sanar'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/wCUa65bVqKQNLasoK94ic1/imagen_5.png',
          alt: 'La Técnica del Yo Siento en la Intimidad'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/dsYK31i7VVcDXYxv72dXF2/imagen_6.png',
          alt: 'Ancla o Trampolín: ¿Cuál Eres?'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/tkZYDtST8TpHjb8tJK8evx/imagen_7.png',
          alt: 'Desenmascarando los Mitos del Amor'
        }]} data-id="element-83" />
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-84">
        <div className="max-w-5xl mx-auto" data-id="element-85">
          <div className="text-center mb-10" data-id="element-86">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-87">
              ✨ Esto es lo que vas a recibir hoy:
            </h2>
            <div className="w-20 h-1 bg-[#27AE60] mx-auto rounded-full" data-id="element-88"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-89">
            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-90">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-91">
                <ShieldCheckIcon className="w-8 h-8" data-id="element-92" />
              </div>
              <div data-id="element-93">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-94">
                  Protocolo de Desescalada
                </h3>
                <p className="text-gray-600" data-id="element-95">
                  La técnica exacta para frenar cualquier discusión en 180
                  segundos.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-96">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-97">
                <TrendingUpIcon className="w-8 h-8" data-id="element-98" />
              </div>
              <div data-id="element-99">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-100">
                  La Rueda de la Satisfacción
                </h3>
                <p className="text-gray-600" data-id="element-101">
                  Un mapa visual para identificar las áreas críticas de tu
                  relación y saber exactamente qué arreglar.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-102">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-103">
                <MessageCircleIcon className="w-8 h-8" data-id="element-104" />
              </div>
              <div data-id="element-105">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-106">
                  Guía de Comunicación Asertiva
                </h3>
                <p className="text-gray-600" data-id="element-107">
                  Cómo pedir lo que necesitás sin que el otro se sienta atacado,
                  y empezar a lograr acuerdos reales.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-108">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-109">
                <HeartHandshakeIcon className="w-8 h-8" data-id="element-110" />
              </div>
              <div data-id="element-111">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-112">
                  El Nuevo Contrato de Pareja
                </h3>
                <p className="text-gray-600" data-id="element-113">
                  Plantillas listas para definir reglas, límites y compromisos
                  concretos que los blinden ante futuros conflictos.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60] md:col-span-2 md:w-1/2 md:mx-auto" data-id="element-114">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-115">
                <BrainCircuitIcon className="w-8 h-8" data-id="element-116" />
              </div>
              <div data-id="element-117">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-118">
                  Auditoría de Pensamientos
                </h3>
                <p className="text-gray-600" data-id="element-119">
                  Ejercicios prácticos para detectar las trampas mentales que te
                  hacen ver a tu pareja como un enemigo, y empezar a verla como
                  tu aliada.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-120">
            <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all animate-pulse" data-id="element-121">
              QUIERO EL MÉTODO COMPLETO AHORA
            </button>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-12 md:py-16 px-4 bg-[#2C3E50] text-white relative overflow-hidden" data-id="element-122">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#27AE60]/10 rounded-full blur-3xl" data-id="element-123"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#27AE60]/10 rounded-full blur-3xl" data-id="element-124"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-125">
          <div className="text-center mb-16" data-id="element-126">
            <span className="bg-[#27AE60] text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-4 inline-block" data-id="element-127">
              🎁 Oferta Especial
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-128">
              BONUS EXCLUSIVOS INCLUIDOS CON TU COMPRA
            </h2>
            <p className="text-xl text-gray-200" data-id="element-129">¡GRATIS POR EL DÍA DE HOY!</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-130">
            <BonusCard number="01" title="Reconexión Íntima" description="Despertá el deseo que se fue apagando con el tiempo. Ejercicios concretos para recuperar la intimidad física y emocional." value="$9.000 ARS" data-id="element-131" />
            <BonusCard number="02" title="Intimidad Radical" description="Recuperá la conexión sexual y emocional profunda con tu pareja." value="$9.000 ARS" data-id="element-132" />
            <BonusCard number="03" title="Reconstrucción Individual" description="Trabajá la ansiedad, el enojo y el miedo que te paralizan adentro de la relación." value="$9.000 ARS" data-id="element-133" />
            <BonusCard number="04" title="Conexión Profunda" description="La gratitud como herramienta real para transformar la dinámica diaria de tu pareja." value="$9.000 ARS" data-id="element-134" />
          </div>

          <div className="bg-[#27AE60]/20 border-2 border-[#27AE60] rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-135">
            <p className="text-lg text-gray-200 mb-2" data-id="element-136">
              VALOR TOTAL DE LOS 4 BONOS:
            </p>
            <div className="flex flex-col items-center justify-center gap-2 text-2xl md:text-3xl font-bold" data-id="element-137">
              <span className="line-through text-gray-400" data-id="element-138">$39.960 ARS</span>
              <span className="text-[#27AE60]" data-id="element-139">
                ✨ Hoy te los llevás por: $0 ✨
              </span>
              <span className="text-white text-lg" data-id="element-140">
                Incluidos GRATIS con tu compra
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="py-16 md:py-24 px-4 bg-gray-50 scroll-mt-20" data-id="element-141">
        <div className="max-w-5xl mx-auto" data-id="element-142">
          {/* COUNTDOWN BOX */}
          <div className="bg-[#2C3E50] rounded-2xl p-8 mb-8 text-center shadow-xl" data-id="element-143">
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-6 uppercase" data-id="element-144">
              El precio de lanzamiento termina en
            </h2>

            <div className="flex justify-center mb-6" data-id="element-145">
              <CountdownTimer initialMinutes={15} showLabels={true} data-id="element-146" />
            </div>

            <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-147">
              <span className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5" data-id="element-148">
                🔥 Últimas unidades disponibles
              </span>
              <span className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5" data-id="element-149">
                📢 Oferta de Lanzamiento
              </span>
              <span className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5" data-id="element-150">
                📈 Precio sube al terminar
              </span>
            </div>

            <div className="max-w-md mx-auto" data-id="element-151">
              <div className="w-full bg-gray-500 rounded-full h-4 overflow-hidden" data-id="element-152">
                <div className="h-4 rounded-full transition-all" style={{
                width: '80%',
                background: 'linear-gradient(to right, #E74C3C, #F39C12)'
              }} data-id="element-153"></div>
              </div>
              <p className="text-sm text-gray-300 font-bold mt-2 uppercase tracking-wider" data-id="element-154">
                80% de cupos ocupados
              </p>
            </div>
          </div>

          {/* TITLE BELOW COUNTDOWN */}
          <h2 id="elegi-tu-pack" className="text-2xl md:text-4xl font-extrabold text-[#2C3E50] mb-3 md:mb-8 text-center scroll-mt-16" data-id="element-155">
            ELEGÍ TU PACK
          </h2>

          <div className="grid md:grid-cols-2 gap-3 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-156">
            {/* PACK ÉLITE - PRIMERO */}
            <button onClick={() => {
            const eliteRadio = document.getElementById('pack-elite') as HTMLInputElement;
            if (eliteRadio) {
              eliteRadio.checked = true;
              setSelectedPrice('$28.990');
            }
          }} className="bg-white border-4 border-[#27AE60] rounded-xl p-3 md:p-6 text-left hover:shadow-xl transition-all relative group shadow-[0_0_15px_rgba(39,174,96,0.3)]" data-id="element-157">
              <div className="absolute top-3 right-3" data-id="element-158">
                <input type="radio" id="pack-elite" name="pack" defaultChecked className="w-5 h-5 accent-[#27AE60]" data-id="element-159" />
              </div>
              <div className="bg-[#27AE60] text-white px-2 py-0.5 rounded-full text-[10px] font-bold inline-block mb-1" data-id="element-160">
                ⭐ MÁS ELEGIDO
              </div>
              <h3 className="text-lg md:text-2xl font-extrabold text-[#2C3E50] mb-1" data-id="element-161">
                ◉ PACK ÉLITE
              </h3>
              <div className="text-xs md:text-sm text-gray-700" data-id="element-162">
                <p className="font-semibold" data-id="element-163">✅ Método Reset 24h + 4 Bonos</p>
                <p className="text-[11px] pl-3 mt-0.5" data-id="element-164">
                  ⭐ <strong data-id="element-165">EXTRA:</strong> Los 5 Errores que Destrozan la
                  Pareja
                </p>
              </div>
              <div className="mt-2 pt-2 border-t border-gray-200 flex items-baseline gap-2" data-id="element-166">
                <span className="text-2xl md:text-3xl font-extrabold text-[#27AE60]" data-id="element-167">
                  $28.990
                </span>
                <span className="text-sm text-gray-400 line-through" data-id="element-168">
                  $58.975
                </span>
                <span className="text-[10px] text-[#E74C3C] font-bold" data-id="element-169">
                  -51%
                </span>
              </div>
            </button>

            {/* PACK BASE - SEGUNDO */}
            <button onClick={() => {
            const baseRadio = document.getElementById('pack-base') as HTMLInputElement;
            if (baseRadio) {
              baseRadio.checked = true;
              setSelectedPrice('$19.990');
            }
          }} className="bg-white border-2 border-[#27AE60] rounded-xl p-3 md:p-6 text-left hover:shadow-xl transition-all relative group hover:border-[#27AE60]" data-id="element-170">
              <div className="absolute top-3 right-3" data-id="element-171">
                <input type="radio" id="pack-base" name="pack" className="w-5 h-5 accent-[#27AE60]" data-id="element-172" />
              </div>
              <h3 className="text-lg md:text-2xl font-extrabold text-[#2C3E50] mb-1" data-id="element-173">
                ○ PACK BASE
              </h3>
              <div className="text-xs md:text-sm text-gray-700" data-id="element-174">
                <p className="font-semibold" data-id="element-175">✅ Método Reset 24h + 4 Bonos</p>
              </div>
              <div className="mt-2 pt-2 border-t border-gray-200 flex items-baseline gap-2" data-id="element-176">
                <span className="text-2xl md:text-3xl font-extrabold text-[#27AE60]" data-id="element-177">
                  $19.990
                </span>
                <span className="text-sm text-gray-400 line-through" data-id="element-178">
                  $49.975
                </span>
                <span className="text-[10px] text-[#E74C3C] font-bold" data-id="element-179">
                  -60%
                </span>
              </div>
            </button>
          </div>

          {/* CHECKOUT BOX */}
          <div className="mt-4 md:mt-8 max-w-2xl mx-auto bg-[#FAF9F6] border-2 border-[#27AE60] rounded-xl p-3 md:p-6 text-center" data-id="element-180">
            <p className="text-[10px] md:text-sm font-extrabold text-gray-800 uppercase tracking-wide mb-2" data-id="element-181">
              ⏰ Oferta válida solo por hoy —{' '}
              {new Date().toLocaleDateString('es-AR', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
            <div className="mb-2 md:mb-4" data-id="element-182">
              <p className="text-sm md:text-lg font-semibold text-gray-700 mb-1" data-id="element-183">
                Total a pagar:
              </p>
              <p className="text-3xl md:text-5xl font-extrabold text-[#27AE60]" data-id="element-184">
                {selectedPrice}
              </p>
            </div>
            <button onClick={() => {
            const eliteChecked = (document.getElementById('pack-elite') as HTMLInputElement)?.checked;
            if (eliteChecked) {
              window.open('https://checkout.nuvoraplus.online/cart/53422556217712:1', '_blank');
            } else {
              window.open('https://checkout.nuvoraplus.online/cart/53422554972528:1', '_blank');
            }
          }} className="w-full bg-[#27AE60] hover:bg-[#229954] text-white px-6 py-3 md:px-8 md:py-4 rounded-xl font-bold text-base md:text-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 animate-pulse" data-id="element-185">
              🔒 QUIERO ESTE PACK
            </button>
            <div className="mt-2 flex justify-center" data-id="element-186">
              <span className="text-xs border border-[#27AE60] bg-[#27AE60]/10 text-[#27AE60] font-bold px-3 py-1 rounded-lg" data-id="element-187">
                💳 Mercado Pago
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO RECEIVE */}
      <section className="py-12 px-4 bg-white border-t border-gray-100" data-id="element-188">
        <div className="max-w-3xl mx-auto" data-id="element-189">
          <h2 className="text-xl md:text-2xl font-bold text-center text-[#2C3E50] mb-6" data-id="element-190">
            📦 CÓMO RECIBÍS EL MATERIAL
          </h2>
          <div className="grid md:grid-cols-3 gap-4" data-id="element-191">
            <div className="bg-[#FAF9F6] p-4 rounded-lg border-2 border-[#27AE60] text-center" data-id="element-192">
              <div className="w-10 h-10 bg-[#27AE60] text-white rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-2" data-id="element-193">
                1
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-194">
                💎 Elegís el pack
              </p>
            </div>

            <div className="bg-[#FAF9F6] p-4 rounded-lg border-2 border-[#27AE60] text-center" data-id="element-195">
              <div className="w-10 h-10 bg-[#27AE60] text-white rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-2" data-id="element-196">
                2
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-197">
                💰 Pagás con Mercado Pago
              </p>
            </div>

            <div className="bg-[#FAF9F6] p-4 rounded-lg border-2 border-[#27AE60] text-center" data-id="element-198">
              <div className="w-10 h-10 bg-[#27AE60] text-white rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-2" data-id="element-199">
                3
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-200">
                📧 Recibís el link al instante
              </p>
            </div>
          </div>
          <div className="bg-[#E74C3C]/10 border-2 border-[#E74C3C] rounded-lg p-3 mt-6" data-id="element-201">
            <p className="text-center text-sm text-gray-700 flex items-center justify-center gap-2" data-id="element-202">
              <AlertCircleIcon className="w-4 h-4 text-[#E74C3C]" data-id="element-203" />
              ⚠️ Si no lo ves, revisá Spam o Correo no deseado.
            </p>
          </div>
        </div>
      </section>

      {/* ABOUT AUTHOR */}
      <section className="py-12 md:py-16 px-4 bg-[#FAF9F6]" data-id="element-204">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 border-4 border-[#27AE60] text-center" data-id="element-205">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-206">
            👩‍💼 QUIÉN SOY
          </h2>
          <div className="w-16 h-1 bg-[#27AE60] mb-6 mx-auto" data-id="element-207"></div>
          <p className="text-gray-700 leading-relaxed text-lg" data-id="element-208">
            Soy <strong data-id="element-209">Rosana Argüello</strong>, coach y especialista en
            vínculos. Creé el <strong data-id="element-210">Método Reset 24h</strong> para darte en
            pocas horas lo que a muchas parejas les lleva meses aprender en
            terapia: herramientas concretas para manejar el conflicto.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-211">
        <div className="max-w-6xl mx-auto" data-id="element-212">
          <div className="text-center mb-8" data-id="element-213">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-214">
              ⭐ Lo que dicen quienes ya lo aplicaron
            </h2>
            <div className="w-20 h-1 bg-[#27AE60] mx-auto rounded-full" data-id="element-215"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-216">
            <TestimonialCard quote="Pensaba que nuestra relación no tenía solución. En menos de 24 horas de leer el método, pudimos hablar sin pelear por primera vez en meses. No lo puedo creer." name="Carolina M." location="Buenos Aires" data-id="element-217" />
            <TestimonialCard quote="Lo leí sola, sin que mi pareja lo leyera, y aun así cambió todo. Las herramientas son tan concretas que empecé a aplicarlas ese mismo día." name="Valentina R." location="Córdoba" data-id="element-218" />
            <TestimonialCard quote="Llevábamos dos años con las mismas peleas. Este método nos dio un lenguaje nuevo para hablar sin hervirnos la sangre. Vale cada peso." name="Marcela G." location="Rosario" data-id="element-219" />
            <TestimonialCard quote="Yo soy muy escéptica con estas cosas, pero lo compré porque ya no sabía qué más hacer. Me sorprendió lo práctico y directo que es. Nada de filosofía, todo acción." name="Sofía L." location="Mendoza" data-id="element-220" />
            <TestimonialCard quote="Mi pareja y yo lo leímos juntos en una noche. Al otro día teníamos un plan claro de qué cambiar. Hacía mucho que no nos sentíamos tan en equipo." name="Andrea P." location="Mar del Plata" data-id="element-221" />
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-8 px-4 bg-[#2C3E50] text-white" data-id="element-222">
        <div className="max-w-xl mx-auto text-center" data-id="element-223">
          <ShieldCheckIcon className="w-12 h-12 text-[#27AE60] mx-auto mb-3" data-id="element-224" />
          <h2 className="text-xl md:text-2xl font-bold mb-2" data-id="element-225">
            🛡️ GARANTÍA DE SATISFACCIÓN TOTAL
          </h2>
          <h3 className="text-lg text-[#27AE60] font-semibold mb-2" data-id="element-226">
            Garantía de 7 días sin preguntas
          </h3>
          <p className="text-sm text-gray-200" data-id="element-227">
            Probalo. Si no sentís un cambio,{' '}
            <strong data-id="element-228">te devolvemos el dinero</strong>.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 md:py-16 px-4 bg-[#FAF9F6]" data-id="element-229">
        <div className="max-w-3xl mx-auto" data-id="element-230">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#2C3E50] mb-8" data-id="element-231">
            ❓ PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-3" data-id="element-232">
            <FAQItem emoji="👥" question="¿Funciona si mi pareja no participa?" answer="Sí, el cambio en tu reacción modifica la dinámica general. El método está diseñado para que puedas aplicar las herramientas vos solo/a y aun así generar cambios reales en la relación." data-id="element-233" />
            <FAQItem emoji="📚" question="¿Es un libro de autoayuda genérico?" answer="No. Es una guía práctica con protocolos, plantillas y ejercicios concretos basados en psicología aplicada a parejas en crisis." data-id="element-234" />
            <FAQItem emoji="📧" question="¿Cómo recibo el material?" answer="PDF descargable al instante en tu celular o tablet. Una vez que completás la compra, recibís un email con el link de descarga inmediata." data-id="element-235" />
            <FAQItem emoji="💰" question="¿Qué pasa si no me sirve?" answer="Tenés 7 días de garantía total. Si sentís que no te aportó nada, te devolvemos cada peso sin preguntas ni vueltas." data-id="element-236" />
            <FAQItem emoji="🎓" question="¿Necesito conocimientos de psicología?" answer="Para nada. Está escrito en un lenguaje simple, directo y sin tecnicismos para que cualquier persona pueda aplicarlo desde el primer momento." data-id="element-237" />
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-12 md:py-16 px-4 bg-white text-center border-t border-gray-200" data-id="element-238">
        <div className="max-w-3xl mx-auto" data-id="element-239">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-4" data-id="element-240">
            🌙 Esta noche podés seguir igual, esperando que algo cambie solo.
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-241">
            O podés hacer algo diferente. 💚
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-242">
            <div className="w-full sm:w-auto text-center" data-id="element-243">
              <p className="font-bold text-gray-700 mb-2" data-id="element-244">
                ○ PACK BASE — $19.990 ARS
              </p>
              <button onClick={() => window.open('https://checkout.nuvoraplus.online/cart/53422554972528:1', '_blank')} className="w-full sm:w-auto bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-md transition-all animate-pulse" data-id="element-245">
                Quiero el Base
              </button>
            </div>

            <div className="w-full sm:w-auto text-center" data-id="element-246">
              <p className="font-bold text-[#27AE60] mb-2" data-id="element-247">
                ◉ PACK ÉLITE ⭐ — $28.990 ARS
              </p>
              <button onClick={() => window.open('https://checkout.nuvoraplus.online/cart/53422556217712:1', '_blank')} className="w-full sm:w-auto bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg transition-all transform hover:scale-105 animate-pulse" data-id="element-248">
                Quiero el Élite
              </button>
            </div>
          </div>

          <p className="text-center text-sm text-gray-500 mt-8 flex items-center justify-center gap-1" data-id="element-249">
            <LockIcon className="w-4 h-4" data-id="element-250" /> Pago seguro · Mercado Pago
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <Footer data-id="element-251" />

      {/* SOCIAL PROOF POPUP */}
      <SocialProofPopup data-id="element-252" />
    </div>;
}